const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function canonicalInstructionRevision(value) {
  const match = typeof value === "string"
    ? value.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,6}))?(?:Z|\+00:00)$/)
    : null;
  if (!match) return null;
  return `${match[1]}.${(match[2] || "").padEnd(6, "0")}Z`;
}

export function mappedIntegrationForSite(integrations, siteId) {
  if (!UUID.test(siteId || "") || !Array.isArray(integrations)) return null;
  const matches = integrations.filter((integration) =>
    Array.isArray(integration?.site_readiness)
      && integration.site_readiness.some((site) => site?.ravo_site_id === siteId));
  return matches.length === 1 && UUID.test(matches[0]?.id || "") ? matches[0] : null;
}

export function productRefs(productIds) {
  if (!Array.isArray(productIds) || productIds.length < 1 || productIds.length > 20
    || new Set(productIds).size !== productIds.length
    || productIds.some((value) => !UUID.test(value || ""))) return null;
  return productIds.map((product_uuid) => ({ product_uuid }));
}

export function instructionActive(start, expiry, now = new Date()) {
  const started = !start || new Date(start).getTime() <= now.getTime();
  const unexpired = !expiry || new Date(expiry).getTime() >= now.getTime();
  return started && unexpired;
}
